import { IuniFlower } from "./IuniFlower";

export default function Navbar() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header data-testid="main-nav" className="fixed top-4 inset-x-0 z-40 px-4">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-2 rounded-full bg-white/70 backdrop-blur-xl border border-gray-200/60 shadow-[0_8px_30px_rgba(0,0,0,0.06)] pl-5 pr-2.5 py-2.5">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-2.5"
        >
          <IuniFlower size={26} />
          <span className="text-xl font-bold tracking-tight text-[#2D2926]">iuni</span>
        </button>
        <nav className="flex items-center gap-1 sm:gap-2">
          <button
            data-testid="nav-come-funziona-button"
            onClick={() => scrollTo("come-funziona")}
            className="hidden sm:inline-flex px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-900 hover:bg-gray-100/70 rounded-full transition-colors"
          >
            Come funziona
          </button>
          <button
            data-testid="nav-richiedi-invito-button"
            onClick={() => scrollTo("waitlist-section")}
            className="px-4 sm:px-5 py-2.5 text-xs sm:text-sm font-semibold text-white rounded-full bg-gradient-to-r from-[#E07A5F] to-[#E2856E] shadow-[0_4px_14px_rgba(224,122,95,0.39)] hover:shadow-[0_6px_20px_rgba(224,122,95,0.3)] hover:-translate-y-0.5 transition-[box-shadow,transform]"
          >
            Unisciti alla lista d'attesa
          </button>
        </nav>
      </div>
    </header>
  );
}
